import { type FirebaseStorage, getDownloadURL } from 'firebase/storage';
import { createStorageRef } from './helpers';

export default function getDownloadURLFactory(storage: FirebaseStorage) {
  return function getDownloadURLFunction(path: string) {
    return getDownloadURL(createStorageRef(storage, path));
  };
}
